import { useColor } from '@precon-tools-suite-by-shared/shared-colors-ui';
import { type MaybeRefOrGetter, toRef, computed } from 'vue';

export function useRiskBadgeColors(
    color: MaybeRefOrGetter<string | null | undefined>
) {
    const c = toRef(color);

    const lightColor = useColor(() => c.value, '300')?.rgbString;
    const darkColor = useColor(() => c.value, '800')?.rgbString;

    const darkStyle = computed(() => ({
        'background-color': darkColor.value,
        color: lightColor.value,
    }));

    const lightStyle = computed(() => ({
        color: darkColor.value,
        'background-color': lightColor.value,
    }));

    return {
        lightColor,
        darkColor,
        darkStyle,
        lightStyle,
    };
}
